module.exports = __webpack_public_path__ + "img/wallet.28a9b1a0.svg";